import React from "react";
import { createStyles, Flex, Paper, Text, useMantineTheme } from "@mantine/core";
import { JsonBlock } from "./JsonBlock";

export type MessageType = {
	text_message: string;
	json_message?: any;
	isValid?: boolean;
	logsUrl?: string;
};

interface IMessage {
	message: MessageType;
	sender?: "ai" | "user";
	onApply: (json: string) => void;
}

export const Message: React.FC<IMessage> = ({ message, sender, onApply }) => {
	const theme = useMantineTheme();
	const { classes } = useStyles();

	return (
		<Flex
			className={classes.message}
			style={{
				flexDirection: sender === "ai" ? "row" : "row-reverse",
			}}
		>
			<Paper
				style={{
					backgroundColor:
						theme.colorScheme === "dark"
							? sender === "ai"
								? "transparent"
								: theme.colors.dark[1]
							: sender === "ai"
								? "transparent"
								: theme.colors.light[1],
					color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.light[3],
					maxWidth: "80%",
					padding: "0.5rem 1rem",
				}}
			>
				<Text>
					<pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", fontFamily: "Open Sans, sans-serif" }}>
						{message.text_message}
					</pre>
				</Text>

				{message.logsUrl ? (
					<Text mt="0.5rem">
						<a href={message.logsUrl} target="_blank" rel="noopener noreferrer">
							Show error logs
						</a>
					</Text>
				) : null}

				{message.json_message ? <JsonBlock content={message.json_message} isValid={message.isValid} onApply={onApply} /> : null}
			</Paper>
		</Flex>
	);
};

const useStyles = createStyles((theme) => ({
	message: {
		width: "100%",
		gap: "1rem",

		"& > .mantine-Paper-root": {
			padding: ".5rem",
			backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[0],
		},
	},
}));
